import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable, map, take, takeUntil } from 'rxjs';
import { getSessionAuthData } from '../states/session-auth/session-auth.selectors';
import { sessionAuthData } from '../interfaces/states-data';

@Injectable({
  providedIn: 'root'
})
export class NoSessionAuthGuard {

  constructor(private store: Store<any>, private _router: Router) {
    console.warn('%c -------> Contructor NoSessionAuthGuard', 'color: white');
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    console.warn('%c -------> canActivate NoSessionAuthGuard', 'color: white');

    // La ruta a la cual se navegara si el guard falla
    // se puede establecer desde el route module
    let invalidRoute = route.data['invalidRoute'] ? route.data['invalidRoute'] : 'home';

    // Se obtiene del reducer el estado de la sesion
    return this.store.pipe(
      select(getSessionAuthData),
      take(1),
      map((data: sessionAuthData) => {

        if (!data.loggedIn) {
          return !data.loggedIn;
        } else {

          console.warn('%c -------> canActivate NoSessionAuthGuard -> false', 'color: white');

          // Navegar al home
          this._router.navigate([invalidRoute]);
          return !data.loggedIn;

        }
      })
    );
  }
}
